import { render, staticRenderFns } from "./DonationLayout.vue?vue&type=template&id=27aa8143&scoped=true&"
import script from "./DonationLayout.vue?vue&type=script&lang=js&"
export * from "./DonationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa8143",
  null
  
)

export default component.exports